import Service from 'react-reservice';

import { ESymbolCategory, ISymbol } from '@aqx-core/common/api/market';

export interface ISearchServiceContext {
  searching: boolean;
  deleting: boolean;
  rawSearchHistories: ISymbol[];
  searchSymbolResult: ISymbol[];
  filteredSymbolHistories: ISymbol[];
  selectedSymbolCategory: ESymbolCategory;
  favouriteSymbolIds: string[];
}

const defaultContext: ISearchServiceContext = {
  searching: false,
  deleting: false,
  rawSearchHistories: [],
  filteredSymbolHistories: [],
  searchSymbolResult: [],
  selectedSymbolCategory: ESymbolCategory.ALL,
  favouriteSymbolIds: []
};

class SearchService extends Service<ISearchServiceContext> {
  constructor() {
    super();

    this.context = defaultContext;
  }

  setSearching = (nextSearching: boolean) => {
    this.context.searching = nextSearching;
  };

  setRawSearchHistories = (nextSearchHistories: ISymbol[]) => {
    this.context.rawSearchHistories = nextSearchHistories;
  };

  setFilteredSearchHistories = (nextFilteredSearchHistories: ISymbol[]) => {
    this.context.filteredSymbolHistories = nextFilteredSearchHistories;
  };

  setSearchSymbolResult = (nextSearchSymbolResult: ISymbol[]) => {
    this.context.searchSymbolResult = nextSearchSymbolResult;
  };

  setSelectedSymbolCategory = (nextSelectedSymbolCategory: ESymbolCategory) => {
    this.context.selectedSymbolCategory = nextSelectedSymbolCategory;
  };

  setDeleting = (nextDeleting: boolean) => {
    this.context.deleting = nextDeleting;
  };

  setFavouriteSymbolIds = (nextFavouriteSymbolIds: string[]) => {
    this.context.favouriteSymbolIds = nextFavouriteSymbolIds;
  };
}

export const searchService = new SearchService();
